module.exports = __webpack_public_path__ + "img/brand01.5b3956e5.png";